export var MessageRecipientType;
(function (MessageRecipientType) {
    MessageRecipientType[MessageRecipientType["Customer"] = 1] = "Customer";
    MessageRecipientType[MessageRecipientType["Agent"] = 2] = "Agent";
})(MessageRecipientType || (MessageRecipientType = {}));
export default MessageRecipientType;
//# sourceMappingURL=message-recipient-type.js.map